<template>
  <section class="main-banner">
    <div class="main-banner--container">
      <hooper :progress="true" :autoPlay="true" :playSpeed="8000" :infiniteScroll="true">
        <slide v-for="(slide, index) in slider"
              :key="index">
          <div class="main-banner--image"
              :class="`main-banner--image__${slide.imgbg}`">
          </div>
            <div class="main-banner__grid">
            <div class="main-banner__grid--text">
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
               width="150.000000pt" height="150.000000pt" viewBox="0 0 340.000000 227.000000"
               preserveAspectRatio="xMidYMid meet">
              <g transform="translate(0.000000,227.000000) scale(0.100000,-0.100000)"
              fill="#e61919" stroke="none">
              <path d="M1410 1640 l-265 -149 0 -171 0 -172 275 -153 275 -153 70 40 c38 21
              85 46 103 55 17 9 32 19 32 22 0 3 -142 84 -315 180 -173 96 -315 177 -315
              181 0 3 24 18 53 34 l52 28 309 -173 c171 -94 318 -174 327 -176 18 -5 209 94
              209 108 0 3 -134 82 -299 173 -164 92 -306 172 -315 179 -14 10 -9 16 37 41
              l53 28 271 -151 c149 -83 274 -151 278 -151 3 0 4 52 3 116 l-3 116 -268 149
              c-147 82 -275 149 -285 148 -9 0 -136 -67 -282 -149z"/>
              <path d="M1142 904 l3 -116 268 -149 c147 -82 274 -149 282 -149 8 0 135 67
              282 149 l268 150 3 117 c2 105 1 116 -14 110 -9 -4 -133 -72 -275 -151 -143
              -80 -261 -145 -264 -145 -2 0 -126 68 -274 150 -148 83 -272 150 -276 150 -3
              0 -4 -52 -3 -116z"/>
              </g>
              </svg>
              <h1 class="main-banner__grid--headline">
                {{ slide.headline }}
              </h1>
            </div>
            <div class="main-banner__grid--photo">
            </div>
          </div>
        </slide>
        <hooper-navigation slot="hooper-addons"></hooper-navigation>
      </hooper>
    </div>
  </section>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: 'MainBanner',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  props: {
    slider: {
      type: Array,
      default: function (){
        return [
          {
            imgbg: "bg-1",
            headline: "ŚWIADCZYMY USŁUGI WSPOMAGAJĄCE TRANSPORT LĄDOWY"
          },
          {
            imgbg: "bg-2",
            headline: "WYRÓŻNIA NAS SZYBKOŚĆ I PRECYZJA"
          },
          {
            imgbg: "bg-3",
            headline: "PRACE MAGAZYNOWE TO NASZA SPECJALNOŚĆ"
          }
        ]
      }
    }
  }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
